import breakpoints from '../../constants/breakpoints';

/**
 * returns a string representing the breakpoint according to the design system specifications
 * @returns string
 */
export const getCurrentBreakpoint = () => {
  const width = global.innerWidth;

  switch ( true ){
    case width < breakpoints.BREAKPOINTS.MEDIUM:
      return breakpoints.DEVICES.SMALL;
    case width >= breakpoints.BREAKPOINTS.MEDIUM && width < breakpoints.BREAKPOINTS.LARGE:
      return breakpoints.DEVICES.MEDIUM;
    case width >= breakpoints.BREAKPOINTS.LARGE && width < breakpoints.BREAKPOINTS.X_LARGE:
      return breakpoints.DEVICES.LARGE;
    case width >= breakpoints.BREAKPOINTS.X_LARGE:
      return breakpoints.DEVICES.X_LARGE;
  }
};

/**
 * returns a string representing the device (mobile or desktop) according to the design system specifications
 * @returns boolean
 */
export const isMobileDisplay = () => {
  if( getCurrentBreakpoint() === breakpoints.DEVICES.LARGE || getCurrentBreakpoint() === breakpoints.DEVICES.X_LARGE ){
    return false;
  }
  else {
    return true;
  }
};

/**
 *  returns if the view is desktop or mobile
 * @param { boolean } isMobileDisplay - overload for setting if the displays is a mobile device
 * @returns string
 */
export const getDeviceInflection = function( isMobileDisplay ){
  if( typeof isMobileDisplay !== 'boolean' ){
    throw new Error( 'Expected an argument of a boolean type' );
  }

  return ( isMobileDisplay ? 'Mobile' : 'Desktop' ).toUpperCase();
};

